import desanitizeString from '../sanitizeUtil/sanitizeUtil';

const getStatusForChecklist = (status, schemaArr) => {
  const query = [];
  schemaArr.forEach((stat) => {
    if (status.includes(desanitizeString(stat.label))) {
      query.push(stat.value);
    }
  });
  return query;
};

export default getStatusForChecklist;
